import React from 'react';
import { Link } from 'react-router-dom';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';
import { Button } from '../components/ui/button';
import Breadcrumb from '../components/Breadcrumb';
import { faqData } from '../mock';

const FAQ = () => {
  return (
    <div className="bg-white py-12">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <Breadcrumb items={[{ label: 'FAQ' }]} />
        
        <h1 className="text-4xl font-bold text-[#0F172A] mb-6">Häufig gestellte Fragen</h1>
        <p className="text-lg text-gray-700 mb-12">
          Hier finden Sie Antworten auf die wichtigsten Fragen rund um Haushaltsauflösungen in Dortmund. 
          Ist Ihre Frage nicht dabei? Kontaktieren Sie uns einfach.
        </p>

        <Accordion type="single" collapsible className="bg-white rounded-lg shadow-sm border border-gray-200">
          {faqData.map((faq, index) => (
            <AccordionItem key={index} value={`item-${index}`}>
              <AccordionTrigger className="px-6 text-left text-[#0F172A] font-semibold hover:text-[#16A34A]">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="px-6 pb-4 text-gray-700">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div className="mt-12 bg-gray-50 rounded-lg p-8 text-center">
          <h2 className="text-2xl font-bold text-[#0F172A] mb-4">Noch Fragen?</h2>
          <p className="text-gray-700 mb-6">
            Wir beantworten gerne alle weiteren Fragen persönlich. Rufen Sie uns an oder nutzen Sie unser Kontaktformular.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button asChild size="lg" className="bg-[#16A34A] hover:bg-[#16A34A]/90 text-white">
              <a href="tel:+4923139085116">0231 39085116</a>
            </Button>
            <Button asChild size="lg" variant="outline" className="border-[#16A34A] text-[#16A34A] hover:bg-[#16A34A] hover:text-white">
              <Link to="/kontakt">Zum Formular</Link>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;